import { DashboardDeviceType } from '@akin-home/amplify';
import { DashboardWidgetType } from '../types';
import { createDashboardModel } from './createDashboardModel';
import { createTabletDashboardFromSelectedWidgets } from './createTabletDashboardFromSelectedWidgets';

export const getDefaultTabletDashboardLayout = () =>
  createDashboardModel({
    device_type: DashboardDeviceType.tablet,
    layout: createTabletDashboardFromSelectedWidgets([
      DashboardWidgetType.CHECKLISTS,
      DashboardWidgetType.CONTACTS,
      DashboardWidgetType.GOAL_CAROUSEL,
    ]),
  });
